export interface OptionSet {
  id: string;
  name: string;
  displayNameAr: string;
  displayNameEN: string;
  optionSetItems: null | OptionSetItem[];
}

// Generated by https://quicktype.io

export interface OptionSetItem {
  id: string;
  value: number;
  nameAr: string;
  nameEn: string;
  optionSet: OptionSet;
  color: string;
  isDefault: boolean;
}
